/** tm/legal/alertPrefs.ts — 새 소식 관련 브라우저 저장값 (본 시점·나중에·PC 알림·첫 안내). 저장 불가 환경이면 조용히 기본값 */

const K = {
  seen: (uid: string) => `tm_legal_seen:${uid || 'me'}`,
  snooze: (uid: string) => `tm_legal_snooze:${uid || 'me'}`,
  pc: 'tm_legal_pcnotify',
  intro: (uid: string) => `tm_legal_intro:${uid || 'me'}`,
};

function read(key: string): string | null {
  try { return localStorage.getItem(key); } catch { return null; }
}
function write(key: string, v: string | null) {
  try { if (v === null) localStorage.removeItem(key); else localStorage.setItem(key, v); } catch { /* 저장 불가 */ }
}

/** 팝업으로 이미 보여 준 가장 늦은 first_seen_at (ISO) */
export const getSeen = (uid: string) => read(K.seen(uid));
export function setSeen(uid: string, iso: string) {
  const cur = getSeen(uid);
  if (!cur || Date.parse(iso) > Date.parse(cur)) write(K.seen(uid), iso);
}

/** 「나중에」 — 이 시각(ms)까지 팝업을 띄우지 않는다 */
export function getSnooze(uid: string): number {
  const v = Number(read(K.snooze(uid)));
  return Number.isFinite(v) ? v : 0;
}
export const setSnooze = (uid: string, until: number) => write(K.snooze(uid), String(until));
export const SNOOZE_MS = 2 * 60 * 60 * 1000;

/** PC 알림 (이 브라우저에서만) */
export const getPcNotify = () => read(K.pc) === '1';
export const setPcNotify = (on: boolean) => write(K.pc, on ? '1' : null);
export const pcSupported = () => typeof window !== 'undefined' && 'Notification' in window;
export type PcPermission = 'default' | 'granted' | 'denied' | 'unsupported';
export const pcPermission = (): PcPermission => (pcSupported() ? Notification.permission : 'unsupported');

/** 첫 방문 안내를 닫았는지 */
export const introClosed = (uid: string) => read(K.intro(uid)) === '1';
export const closeIntro = (uid: string) => write(K.intro(uid), '1');

/** 동작 줄이기 설정 */
export function reducedMotion(): boolean {
  try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch { return false; }
}
